// Google Maps API key
module.exports.GOOGLE_MAP_API_KEY = "AIzaSyBVnx5wLK107cb9_LhaIqT-6NF53Imu3Fc";
module.exports.STRIPE_API_KEY = "pk_test_J6cBl4bWE3Urc6dNXGPu3kcD00aEZ0uK0q";

module.exports.PAYMENT_METHOD_CREDIT_CARD = "creditcard";
module.exports.PAYMENT_METHOD_ALIPAY = "alipay";

module.exports.HW_DRIVER_URL = 'http://localhost:8001';
